/**
 * Owner: Masa Bayu
 * File: qx-writer-editor.ts
 * Date:Time: 2026-10-05 16:26
 * Description: Fasa 32 GREEN · LexicalComposer config · UniversalTextNode registered.
 */

import { ParagraphNode, TextNode } from 'lexical';
import { UniversalTextNode } from './universal-text-node';

export interface EditorConfig {
  namespace: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Lexical Klass[] until React phase
  nodes: any[];
  onError: (error: Error) => void;
}

/** InitialConfig shape for LexicalComposer · Fasa 33 mounts React. */
export function getEditorConfig(): EditorConfig {
  return {
    namespace: 'QXWriter-Universal-Editor',
    nodes: [
      ParagraphNode,
      TextNode,
      UniversalTextNode,
    ],
    onError: (error) => {
      console.error('QXWriter Editor Error:', error);
      throw error;
    },
  };
}
